import {checkMailSvg} from './svgs/checkmail';
import {logoSvg} from './svgs/logo';
import {greenArrowSvg} from './svgs/green-arrow';
import {errorSvg} from './svgs/error';
import { wixSsoSvg } from './svgs/wix-sso';
import { mobileLockSvg } from './svgs/mobile-lock';
import { screenSvg } from './svgs/screen.svg';
import { TenantCreatedSvg } from './svgs/tenant-created.svg';

export const iconsMap = {
	wixLogo: logoSvg,
	wixSso: wixSsoSvg,
	checkEmail: checkMailSvg,
	validInput: greenArrowSvg,
	invalidInput: errorSvg,
	mobileLock: mobileLockSvg,
	mobileLockSignup: TenantCreatedSvg,
	mobileLockBottomScreen: screenSvg
};
